"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResetPasswordScreen = void 0;
var react_1 = __importStar(require("react"));
var CheckCircle_1 = __importDefault(require("@mui/icons-material/CheckCircle"));
var ResetPasswordScreenBase_1 = require("./ResetPasswordScreenBase");
var contexts_1 = require("../../contexts");
var constants_1 = require("../../constants");
var utils_1 = require("../../utils");
var useErrorManager_1 = require("../../contexts/ErrorContext/useErrorManager");
var react_i18next_1 = require("react-i18next");
/**
 * Component that renders a ResetPassword screen that allows a user to reset their password and shows a success message upon a successful password reset..
 *
 * @param PasswordProps props that will be passed to the SetPassword component
 * @param showSuccessScreen boolean that determines whether to show the success screen or not
 * @param slots used for ResetPasswordScreen SuccessScreen props
 * @param slotProps props that will be passed to the SuccessScreen component
 * @param errorDisplayConfig configuration for customizing how errors are displayed
 * @param SuccessScreen component that will be rendered when showSuccessScreen is true
 * @param WorkflowCardBaseProps props that will be passed to the WorkflowCard component
 * @param WorkflowCardHeaderProps props that will be passed to the WorkflowCardHeader component
 * @param WorkflowCardInstructionProps props that will be passed to the WorkflowCardInstructions component
 * @param WorkflowCardActionsProps props that will be passed to the WorkflowCardActions component
 * @returns a React JSX Element that renders a ResetPassword screen
 *
 * @category Component
 *
 */
var ResetPasswordScreen = function (props) {
    var _a, _b, _c, _d;
    var t = (0, react_i18next_1.useTranslation)().t;
    var passwordRef = (0, react_1.useRef)(null);
    var confirmRef = (0, react_1.useRef)(null);
    var _e = (0, useErrorManager_1.useErrorManager)(), triggerError = _e.triggerError, errorManagerConfig = _e.errorManagerConfig;
    var errorDisplayConfig = __assign(__assign(__assign({}, errorManagerConfig), props.errorDisplayConfig), { onClose: function () {
            if (props.errorDisplayConfig && props.errorDisplayConfig.onClose)
                props.errorDisplayConfig.onClose();
            if (errorManagerConfig.onClose)
                errorManagerConfig === null || errorManagerConfig === void 0 ? void 0 : errorManagerConfig.onClose();
        } });
    var WorkflowCardBaseProps = props.WorkflowCardBaseProps, WorkflowCardHeaderProps = props.WorkflowCardHeaderProps, WorkflowCardInstructionProps = props.WorkflowCardInstructionProps, WorkflowCardActionsProps = props.WorkflowCardActionsProps, PasswordProps = props.PasswordProps, _f = props.slots, slots = _f === void 0 ? {} : _f, _g = props.slotProps, slotProps = _g === void 0 ? {} : _g;
    var _h = (0, react_1.useState)((_a = PasswordProps === null || PasswordProps === void 0 ? void 0 : PasswordProps.initialNewPasswordValue) !== null && _a !== void 0 ? _a : ''), passwordInput = _h[0], setPasswordInput = _h[1];
    var _j = (0, react_1.useState)((_b = PasswordProps === null || PasswordProps === void 0 ? void 0 : PasswordProps.initialConfirmPasswordValue) !== null && _b !== void 0 ? _b : ''), confirmInput = _j[0], setConfirmInput = _j[1];
    var _k = (0, react_1.useState)(false), hasVerifyCodeError = _k[0], setHasVerifyCodeError = _k[1];
    var _l = (0, react_1.useState)(false), isLoading = _l[0], setIsLoading = _l[1];
    var _m = (0, react_1.useState)(false), showSuccessScreen = _m[0], setShowSuccessScreen = _m[1];
    var _o = (0, utils_1.parseQueryString)(window.location.search), code = _o.code, email = _o.email;
    var _p = (0, contexts_1.useAuthContext)(), actions = _p.actions, navigate = _p.navigate, routeConfig = _p.routeConfig;
    var passwordRequirements = (0, constants_1.defaultPasswordRequirements)(t);
    var verifyResetCode = (0, react_1.useCallback)(function () { return __awaiter(void 0, void 0, void 0, function () {
        var _error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, 3, 4]);
                    setIsLoading(true);
                    return [4 /*yield*/, actions.verifyResetCode(code, email)];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 2:
                    _error_1 = _a.sent();
                    setHasVerifyCodeError(true);
                    triggerError(_error_1);
                    return [3 /*break*/, 4];
                case 3:
                    setIsLoading(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); }, []);
    var handleOnNext = (0, react_1.useCallback)(function () { return __awaiter(void 0, void 0, void 0, function () {
        var _error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, 3, 4]);
                    setIsLoading(true);
                    return [4 /*yield*/, actions.setPassword(code, passwordInput, email)];
                case 1:
                    _a.sent();
                    if (props.showSuccessScreen === false) {
                        navigate(routeConfig.LOGIN);
                    }
                    else {
                        setShowSuccessScreen(true);
                    }
                    return [3 /*break*/, 4];
                case 2:
                    _error_2 = _a.sent();
                    triggerError(_error_2);
                    return [3 /*break*/, 4];
                case 3:
                    setIsLoading(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [actions, code, passwordInput, email, triggerError, props.showSuccessScreen, navigate, routeConfig]);
    var areValidMatchingPasswords = (0, react_1.useCallback)(function () {
        var _a;
        if (((_a = PasswordProps === null || PasswordProps === void 0 ? void 0 : PasswordProps.passwordRequirements) === null || _a === void 0 ? void 0 : _a.length) === 0) {
            return confirmInput === passwordInput;
        }
        for (var i = 0; i < passwordRequirements.length; i++) {
            if (!new RegExp(passwordRequirements[i].regex).test(passwordInput))
                return false;
        }
        return confirmInput === passwordInput;
    }, [(_c = PasswordProps === null || PasswordProps === void 0 ? void 0 : PasswordProps.passwordRequirements) === null || _c === void 0 ? void 0 : _c.length, passwordRequirements, passwordInput, confirmInput]);
    var updateFields = (0, react_1.useCallback)(function (fields) {
        setPasswordInput(fields.password);
        setConfirmInput(fields.confirm);
    }, [setPasswordInput, setConfirmInput]);
    (0, react_1.useEffect)(function () {
        // eslint-disable-next-line
        verifyResetCode();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var workflowCardBaseProps = __assign({ loading: isLoading }, WorkflowCardBaseProps);
    var workflowCardHeaderProps = __assign({ title: t('bluiCommon:FORMS.RESET_PASSWORD') }, WorkflowCardHeaderProps);
    var workflowCardInstructionProps = __assign({ instructions: t('bluiAuth:CHANGE_PASSWORD.PASSWORD_INFO') }, WorkflowCardInstructionProps);
    var workflowCardActionsProps = __assign(__assign({ showNext: true, showPrevious: true, nextLabel: t('bluiCommon:ACTIONS.NEXT'), previousLabel: t('bluiCommon:ACTIONS.BACK'), canGoNext: passwordInput !== '' && confirmInput !== '' && areValidMatchingPasswords() }, WorkflowCardActionsProps), { onNext: function () {
            var _a;
            void handleOnNext();
            (_a = WorkflowCardActionsProps === null || WorkflowCardActionsProps === void 0 ? void 0 : WorkflowCardActionsProps.onNext) === null || _a === void 0 ? void 0 : _a.call(WorkflowCardActionsProps);
        }, onPrevious: function () {
            var _a;
            navigate(routeConfig.LOGIN);
            (_a = WorkflowCardActionsProps === null || WorkflowCardActionsProps === void 0 ? void 0 : WorkflowCardActionsProps.onPrevious) === null || _a === void 0 ? void 0 : _a.call(WorkflowCardActionsProps);
        } });
    var passwordProps = __assign(__assign({ newPasswordLabel: t('bluiAuth:CHANGE_PASSWORD.NEW_PASSWORD'), confirmPasswordLabel: t('bluiAuth:CHANGE_PASSWORD.CONFIRM_NEW_PASSWORD'), passwordNotMatchError: t('bluiCommon:FORMS.PASS_MATCH_ERROR'), passwordRequirements: (_d = PasswordProps === null || PasswordProps === void 0 ? void 0 : PasswordProps.passwordRequirements) !== null && _d !== void 0 ? _d : passwordRequirements, passwordRef: passwordRef, confirmRef: confirmRef }, PasswordProps), { initialNewPasswordValue: passwordInput, initialConfirmPasswordValue: confirmInput, onPasswordChange: function (passwordData) {
            var _a;
            updateFields(passwordData);
            (_a = PasswordProps === null || PasswordProps === void 0 ? void 0 : PasswordProps.onPasswordChange) === null || _a === void 0 ? void 0 : _a.call(PasswordProps, passwordData);
        }, onSubmit: function () {
            var _a, _b;
            if (areValidMatchingPasswords()) {
                void handleOnNext();
                (_a = WorkflowCardActionsProps === null || WorkflowCardActionsProps === void 0 ? void 0 : WorkflowCardActionsProps.onNext) === null || _a === void 0 ? void 0 : _a.call(WorkflowCardActionsProps);
                (_b = PasswordProps === null || PasswordProps === void 0 ? void 0 : PasswordProps.onSubmit) === null || _b === void 0 ? void 0 : _b.call(PasswordProps);
            }
        } });
    return (react_1.default.createElement(ResetPasswordScreenBase_1.ResetPasswordScreenBase, { WorkflowCardBaseProps: workflowCardBaseProps, WorkflowCardHeaderProps: workflowCardHeaderProps, WorkflowCardInstructionProps: workflowCardInstructionProps, WorkflowCardActionsProps: workflowCardActionsProps, PasswordProps: passwordProps, showSuccessScreen: showSuccessScreen, slots: slots, slotProps: {
            SuccessScreen: __assign({ icon: react_1.default.createElement(CheckCircle_1.default, { color: "primary", sx: { fontSize: 100 } }), messageTitle: t('bluiAuth:PASSWORD_RESET.SUCCESS_MESSAGE'), message: t('bluiAuth:CHANGE_PASSWORD.SUCCESS_MESSAGE'), WorkflowCardActionsProps: {
                    showPrevious: false,
                    fullWidthButton: true,
                    showNext: true,
                    nextLabel: t('bluiCommon:ACTIONS.DONE'),
                    onNext: function () {
                        navigate(routeConfig.LOGIN);
                    },
                } }, slotProps.SuccessScreen),
        }, errorDisplayConfig: __assign(__assign({}, errorDisplayConfig), { onClose: hasVerifyCodeError
                ? function () {
                    navigate(routeConfig.LOGIN);
                    // eslint-disable-next-line no-unused-expressions
                    errorDisplayConfig.onClose;
                }
                : errorDisplayConfig.onClose }) }));
};
exports.ResetPasswordScreen = ResetPasswordScreen;
